import { render, staticRenderFns } from "./formOrdonnance.vue?vue&type=template&id=aa70ddae&"
import script from "./formOrdonnance.vue?vue&type=script&lang=js&"
export * from "./formOrdonnance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports